export enum FeatureToggle {
  AioliEnabled = 'rt_aioli',
}
